
export const DEFAULT_SPEAKER = 'Speaker';
export const PUNC = 'punc';
export const TURN = 'turn';
export const WORD = 'word';
export const DEFAULT_RANGE = 'marked';

export const TYPE_TERM = 'Term';
export const TYPE_ARRAY = 'array';
export const TYPE_OBJECT = 'object';
export const TYPE_STRING = 'string';
export const TYPE_VALUE = 'value'; // NONE OF THE OTHER TYPES
export const TYPE_NULL = 'null';

export const SPEAKER_COLOR_1 = '#9aca62';
export const SPEAKER_COLOR_2 = '#0079c0';

export const SPEAKER_COLORS = [SPEAKER_COLOR_1, SPEAKER_COLOR_2, 'red'];
